import { Card, CardBody, CardText, CardTitle, Col, Row } from 'reactstrap';
import { Contact } from '../../../types/campaign';
import { getDashColor } from '../icons';

export interface ContactProps {
  contact?: Contact;
}

export const ContactCard = ({ contact }: ContactProps) => {
  if (!contact) {
    return <></>;
  }
  const { name, email, phone } = contact;

  return (
    <Card
      className='d-none d-md-block'
      style={{
        background: getDashColor('supporters'),
      }}
    >
      <CardBody
        style={{
          padding: '15px',
        }}
      >
        <CardTitle className='eyebrow' style={{ fontSize: '14px' }}>
          Client Services Coordinator
        </CardTitle>
        <Row >
          <Col sm='8'>
            <CardText style={{ fontWeight: '900', fontSize: '14px' }}>
              {name}
            </CardText>
          </Col>
        </Row>
        <Row className='mb-2'>
          <Col>
            <CardText
              style={{
                fontSize: '12px',
              }}
            >
              <a href={`mailto:${email}`}>{email}</a>
              {email && <span style={{ margin: '0 4px' }}>&bull;</span>}
              <a href={`tel:${phone}`}>{phone}</a>
            </CardText>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};
